module.exports = __webpack_public_path__ + "static/img/aepic-7.2d23fac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-7.jpg
// module id = 8Aud
// module chunks = 52